import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { getServiceOption } from "../../helpers/api/serviceOption";
import { serviceOptionApiResponseSuccess, serviceOptionApiResponseError } from "./actions";
import { ServiceOptionActionTypes } from "./constants";

/**
 * 
 * Get List Issue Type
 * @param {*} payload
 * @query - enum, []
 * 
 */

function* serviceOption({ payload }) {
    try {
        const response = yield call(getServiceOption, payload.params);
        yield put(serviceOptionApiResponseSuccess(ServiceOptionActionTypes.GET_SERVICE_OPTION, response.data));
    } catch(error) {
        yield put(serviceOptionApiResponseError(ServiceOptionActionTypes.API_RESPONSE_ERROR, error))
    }
};

export function* watchServiceOption() {
    yield takeEvery(ServiceOptionActionTypes.GET_SERVICE_OPTION, serviceOption);
};


function* serviceOptionSaga() {
    yield all([
        fork(watchServiceOption)
    ])
}

export default serviceOptionSaga;